import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";

const LEVELS = {
  B1: "text-purple-600",
  B2: "text-orange-500",
  C1: "text-pink-500",
};

const ElabWaitModel = ({ isOpen, toggle, message, level }) => {
  const [textColor, setTextColor] = useState(LEVELS[level] || "text-black");

  useEffect(() => {
    if (level) {
      localStorage.setItem("userLevel", level);
      setTextColor(LEVELS[level]);
    }
  }, [level]);

  useEffect(() => {
    const savedLevel = localStorage.getItem("userLevel");
    if (savedLevel && LEVELS[savedLevel]) {
      setTextColor(LEVELS[savedLevel]);
    }
  }, []);

  return (
    <Modal
      isOpen={isOpen}
      size="md"
      toggle={toggle}
      className="modal-dialog-centered"
      backdrop="static"
      data-tc="wait-modal"
    >
      <ModalBody className="p-0 py-4">
        <h4 className={`${textColor} text-center`}>
          <div>
            <strong>Our AI is grading your work</strong>
          </div>
          <div className={`spinner-border ${textColor} mt-3 fs-5`} role="status">
            <span className="sr-only"></span>
          </div>
        </h4>
        <p className="text-center">
          <strong>
            {message}
            <p className="pt-1">This process can take up to 60 seconds</p>
          </strong>
        </p>
      </ModalBody>
    </Modal>
  );
};

ElabWaitModel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  level: PropTypes.oneOf(["B1", "B2", "C1"]).isRequired,
};

ElabWaitModel.defaultProps = { isOpen: false };

export default ElabWaitModel;
